/**
 * Open social share links in a centered popup window.
 *
 * Always pass explicit width/height/left/top to window.open() so browsers that
 * honor popup chrome sizing get a compact share dialog. Safari currently often
 * ignores these features (or opens a full tab) due to popup / anti-spoofing
 * policy — keep requesting them anyway in case that policy changes.
 *
 * If the popup is blocked, fall back to a normal new tab.
 */
'use strict';

;( () => {
	// Requested popup size. Chrome/Firefox typically honor these; Safari may not.
	const POPUP_WIDTH  = 600;
	const POPUP_HEIGHT = 640;

	document.addEventListener( 'click', ( event ) => {
		const link = event.target.closest( 'a.component--share__link[data-share-popup]' );

		if ( ! link ) {
			return;
		}

		const url = link.getAttribute( 'href' );

		if ( ! url ) {
			return;
		}

		event.preventDefault();

		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop  = window.screenTop !== undefined ? window.screenTop : window.screenY;
		const viewportWidth  = window.innerWidth || document.documentElement.clientWidth || screen.width;
		const viewportHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;
		const left           = Math.max( 0, ( ( viewportWidth / 2 ) - ( POPUP_WIDTH / 2 ) ) + dualScreenLeft );
		const top            = Math.max( 0, ( ( viewportHeight / 2 ) - ( POPUP_HEIGHT / 2 ) ) + dualScreenTop );

		// Feature string is the instruction to the browser. Do not strip size/
		// position for Safari — leave them in place for engines that respect them.
		const features = [
			`width=${ POPUP_WIDTH }`,
			`height=${ POPUP_HEIGHT }`,
			`left=${ Math.round( left ) }`,
			`top=${ Math.round( top ) }`,
			'noopener',
			'noreferrer',
			'scrollbars=yes',
			'resizable=yes',
		].join( ',' );

		const popup = window.open( url, 'avincSharePopup', features );

		if ( popup ) {
			popup.focus();
		} else {
			// Popup blocked — fall back to a normal new tab.
			window.open( url, '_blank', 'noopener,noreferrer' );
		}
	} );
} )();
